import styled from 'styled-components';

export const ScDownloadButtons = styled.div`
  display: flex;
  gap: 12px;
  .button-download {
    transition: transform 0.3s;

    @media (hover: hover) {
      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;
